import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import CommonTable from "../components/shared/CommonTable";
import StateAPI from "../api/StateAPI";
import StateActionAPI from "../api/StateActionAPI";
import WorkFlowMenuAPI from "../api/WorkFlowMenuAPI";
import CaseState from "../dto/CaseState";
import _ from "lodash";
import DeleteModal from "../components/shared/DeleteModal";
import CommonActionButton from "../components/shared/CommonActionButton";
import CaseStateModal from "../components/caseState/CaseStateModal";
import StateDetails from "../components/caseState/StateDetails";
import feather from 'feather-icons';
import WorkflowAPI from "../api/WorkflowAPI";
import CaseExpression from "../components/shared/CaseExpression";
import { CommonContext } from "../context/CommonContext";
import { sortWorkflowAttributes } from "../utils/sortingUtils";
import Loading from "../components/shared/Loading";
const $ = window.$;

class SettingsCaseStatePage extends Component {
    static contextType = CommonContext;
    ref = React.createRef();

    state = {
        caseState: new CaseState(),
        t : this.props.t,
        stateData : null,
        columns: [],
        data: [],
        isEdit: false,
        selectAction: null,
        caseActions: [],
        records: [],
        errors: {},
        handleRecords: [],
        selectedIdFromModal: null,
        selectedRecordId: null,
        displayCustomWorkflowStateName: true,
        selectedButton: "",
        workflowList: [],
        selectWorkflow: "",
        caseAccessExpressions: [],
        workflowAttributes: [],
        autoSuggestedAttributeValues: [
            {
                workflowName: ["Tipsl?sning (CCM)", "Whistle - Demo", "Demo_wf", "CCM connection"],
                stateName: ["Submitted", "Rejected", "Approved", "Under_work"],
                applicantName: ["Anonymous"]
            }
        ],
        isShowWFSelect: false,
        attributesSorted: [], // Cached sorted attributes
        loading: false,
    };

    onRowClick = stateData => {
        let actions = stateData.actions;
        let newData = [];
        let selectedWF = {};
        const { workflowList } = this.state;
        actions.forEach(item =>{
            let record = {
                id: item.id,
                name: item.name,
                description: item.description,
                title : item.title,
                tooltip : item.tooltip,
                icon : item.icon,
                type : item.type,
                predefinedActions : item.predefinedActions,
                isCommentSection : item.isCommentSection,
                isMandatoryComment : item.isMandatoryComment,
                isCaseHistoryEntry : item.isCaseHistoryEntry,
                isCaseHistoryLogPdf : item.isCaseHistoryLogPdf,
                caseHistoryEntryTitle : item.caseHistoryEntryTitle,
                confirmActionButtonLabel : item.confirmActionButtonLabel,
                cancelActionButtonLabel : item.cancelActionButtonLabel,
                commentHintText : item.commentHintText,
                isTransitionState : item.isTransitionState,
                caseTransitionState : item.caseTransitionState,
                order : item.order,
                successMessage : item.successMessage,
                caseExpressions : item.caseExpressions,
                selectedWorkflowId : item.selectedWorkflowId,
                pinned: item.pinned,
                workflowLink: item.workflowLink
            };
            newData.push(record);
            if (record.pinned !== null && record.pinned === "true") {
                this.setState({
                    selectedRecordId : record.id,
                    selectedIdFromModal: record.order - 1
                });
            }
        })



        let caseAccessExpressions = stateData.caseExpressions;
        if (!!caseAccessExpressions && caseAccessExpressions.length != 0) {
            _.forEach(caseAccessExpressions, function (obj) {
                if (obj.type.toUpperCase() === 'DATE') {
                    obj.value = new Date(obj.value);
                }
            }
            );
        }
        if (stateData.selectedWorkflowId) {
            this.updateWorkflowAttributes(stateData.selectedWorkflowId);
            this.selectedWf = _.find(workflowList, { workflowId: stateData.selectedWorkflowId });
        }
        this.setState({
            stateData: stateData,
            caseState: stateData,
            isEdit: true,
            records: newData,
            handleRecords: [],
            selectedButton : stateData.workflowStateName,
            caseAccessExpressions: caseAccessExpressions || [],
            selectWorkflow: stateData.selectedWorkflowId,
            isShowWFSelect: stateData.selectedWorkflowId ? true : false
        });

        if ((this.state.caseState.workflowStateName && (this.state.caseState.workflowStateName === "All_Applications" || this.state.caseState.workflowStateName === "My_Cases")) || this.state.isShowWFSelect) {
            $('#workflowStateNameRow').hide();
        } else {
            $('#workflowStateNameRow').show();
        }
    };

    updateWorkflowAttributes(workflowId){
                WorkflowAPI.getWorkflowAttributes(workflowId).then(data => {
                    const attributesSorted = this.generateSortedAttributeList ? this.generateSortedAttributeList(data) : sortWorkflowAttributes(data);
                    this.setState({
                        workflowAttributes: data,
                        attributesSorted
                    })
                })
    };

    loadCaseActions(){
        StateActionAPI.all().then(data => {
            this.setState({caseActions: data.data})
        })
    }

    handleWorkflowChange = event => {
        let { name, value } = event.target;
        const { workflowList } = this.state;

        if (name === "selectWorkflowCaseTable") {
            this.setState({
                selectWorkflow: value,
                caseAccessExpressions: [],
                caseState: {
                    ...this.state.caseState,
                    [event.target.name]: value
                }
            });

            this.updateWorkflowAttributes(value);

        } else {
            this.setState({
                caseState: {
                    ...this.state.caseState,
                    [event.target.name]: value
                }
            });
        }
    };

    // Added (mirrors logic found in other pages) to enrich attributes with attributeName used by CaseExpression
    generateAttributeName = (attribute) => {
        if (attribute && (attribute.includes("metadata") || attribute.includes("auditInfo"))) {
            const valueArray = attribute.split(".");
            if (valueArray[1]) {
                return valueArray[1];
            }
        }
        return attribute;
    }

    generateSortedAttributeList = (workflowAttributesTemp = []) => {
        const workflowAttributesSorted = workflowAttributesTemp.map(option => {
            const attribName = this.generateAttributeName(option.attribute || option.attributeName);
            const isDefault = [
                "sessionRef","workflowRef","worker","Attachments","Assign Worker","workflowId","workflowName","workflowVersion",
                "baseURL","continuationURL","stateName","stateType","caseState"
            ].some(k => attribName && attribName.includes(k));
            return {
                id: option.id,
                attribute: option.attribute,
                attributeName: isDefault ? `${attribName} (default)` : attribName,
                type: option.type
            }
        });
        return sortWorkflowAttributes(workflowAttributesSorted);
    }

    reverseOnRowClick=()=>{
        this.setState({
            stateData: null,
            caseState: new CaseState(),
            isEdit: false,
            records: [],
            handleRecords: [],
            workflowList: [],
            selectWorkflow: "",
            caseAccessExpressions: [],
            workflowAttributes: [],
            isShowWFSelect: false
        });
        this.componentDidMount();
    }

    componentDidMount() {
        feather.replace();
        this.hideFields()
        this.updateStateTable();
        this.updateCaseStateActions();
        this.getWorkflows();
        this.loadCaseActions();
    }



    getWorkflows() {
        WorkflowAPI.getWorkflows().then(data => this.setState({ workflowList: data }));
    }

    hideFields() {
        $('#workflowStateNameRow').hide();
    }

    updateStateTable() {
        let { columns, t } = this.state;

        function getColumns (column,t) {
            var translation = t("portalSettings.caseStates.fields."+column.field);
            if(!translation.includes("portalSettings.caseStates.fields")){
                column.title = translation;
            }
        }

        StateAPI.all().then(data => {
            _.forEach(data.columns, function (column) {
                getColumns(column, t)
            });

            columns = [...data.columns];

            this.setState({
                columns: columns,
                data: data.data,
                caseState: new CaseState(),
                stateData : null,
                isEdit: false,
                selectAction: null,
                records: [],
                errors: {},
                handleRecords: [],
                isShowWFSelect: false
            });
        });
    }

    updateCaseStateActions(){
        StateActionAPI.all().then(data => {
            this.setState({caseActions: data.data})
        })
    }

    handleChange = event => {
        let { name, value } = event.target;
        if (event.target.options) {
            value = [...event.target.selectedOptions].map(option => option.value);
        }
        if (name === "status") {
            value = event.target.checked ? "ACTIVE" : "INACTIVE";
        }
        this.setState({
            caseState: {
                ...this.state.caseState,
                [event.target.name]: value
            }
        });

    };

    deleteCaseState = (id,name) => {
        const { t } = this.state;

        if(name=="All_Applications") {
            $.notification("error", t("common.notification.error"), t("portalSettings.caseStates.validationError.CASE_STATE_DEFAULT_DELETE"));
            return;
        }

        StateAPI.delete(id).then(() => {
           $.notification("success", t("common.notification.success"), t("common.validations.RECORD_DELETED_SUCCESS"));
           this.updateStateTable();
        }).catch(error => {
            this.errorHandling(error);
        });
    };

    handleSave = event => {
        const { t, isShowWFSelect, selectWorkflow } = this.state;

        let {
            name,
            workflowStateName,
            description,
            buttonStyle,
            helpText,
            workflowStateIcon,
        } = this.state.caseState;
        let selectedWorkflowId = selectWorkflow;

        event.preventDefault();

        let caseStateObj = new CaseState(
            "",
            name,
            workflowStateName,
            description,
            buttonStyle,
            workflowStateIcon,
            helpText,
            [],
            [],
            isShowWFSelect ? selectedWorkflowId : "",
            []
        );

        let stateApiPromise;

        if (!this.isFormValid(caseStateObj)) return;

        this.setState({loading: true});

        let newRecords = [];

        this.state.handleRecords.forEach(record => {
            let newRecord = { ...record };
            if (record.type === "4") {
                if ((this.state.selectedIdFromModal !== null) && (this.state.selectedRecordId === record.id)) {
                    newRecord.pinned = "true";
                } else {
                    newRecord.pinned = "false";
                }
            }

            newRecords.push(newRecord);
        });

        this.state.handleRecords = newRecords;
        if (selectedWorkflowId && isShowWFSelect) {
            caseStateObj.caseExpressions = this.state.caseAccessExpressions;

            caseStateObj.caseExpressions.forEach(expression => {
                expression.workflowId  = selectedWorkflowId;
            });
        }

        if(this.state.isEdit) {
            if(caseStateObj.id === null || caseStateObj.id === "") {
                caseStateObj.id = this.state.stateData.id;
            }

            if(caseStateObj.actions==null || caseStateObj.actions.length==0){
                caseStateObj.actions = this.resetActionOrder(this.state.handleRecords);
            }

            stateApiPromise = StateAPI.update(caseStateObj);

        } else {
            caseStateObj.actions = this.resetActionOrder(this.state.handleRecords);

            stateApiPromise = StateAPI.save(caseStateObj);
        }

        this.closeModal();

        stateApiPromise
            .then(() => {
                $.notification("success", t("common.notification.success"), t("common.validations.RECORD_SAVED_SUCCESS"));
                this.updateStateTable();
                return WorkFlowMenuAPI.reinitialize();  // Call reinitialize only after save/update
            })
            .then(menuData => {
                this.context.handleSideMenuUpdate(true);
                this.props.menuHandler(menuData);
                if(!this.context.isLoadingStatistics) {
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                this.errorHandling(error);
            }).finally(() => {
                this.setState({loading: false});
            });
    }

    errorHandling = error => {
        const { t } = this.state;

        if (error.response) {
            $.notification("error", t("common.notification.error"), t("portalSettings.caseStates.validationError."+error.response.data));
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log('Error', error.message);
        }
    }

    closeModal = () => {
        $(function () {
            $('#modal-case-state').modal('hide');
        });
    }

    openModal = () => {
        if(this.state.errors!=null && this.state.errors.length!=0){
            this.setState({
                errors: []
            });
        }

        if(this.state.isEdit){
            this.setState({
                handleRecords: this.state.records
            });
        } else {
            this.setState({
                handleRecords: []
            });
            this.setState({
                selectedButton: ""
            });
        }

        $(function () {
            $('#modal-case-state').find('form').trigger('reset');
            $('#modal-case-state').modal('show');
        });

    }

    isFormValid = caseObject => {
        const { t } = this.state;

        const errors = {};
        if (!caseObject.name)
            errors.name = t(
                "portalSettings.caseStates.validationError.NAME_REQUIRED"
            );

            if (!caseObject.workflowStateName && !caseObject?.selectedWorkflowId)
            errors.workflowStateName = t(
                "portalSettings.caseStates.validationError.WORKFLOW_STATE_NAME_REQUIRED"
            );

        if (!caseObject.buttonStyle)
            errors.buttonStyle = t(
                "portalSettings.caseStates.validationError.BUTTON_STYLE_REQUIRED"
            );

        this.setState({
            errors: errors
        });
        return Object.keys(errors).length === 0;
    }

    handleCaseActionChange = event => {
        let { name, value } = event.target;
        const { caseActions } = this.state;
        let selectedAction = _.find(caseActions, { id: parseInt(value) });
        this.setState({
            selectAction: selectedAction.id
        });
    }

    addCaseAccessExpression = (optionList) => {
        const { caseAccessExpressions, selectWorkflow } = this.state;
        let isCondition = "";
        if (caseAccessExpressions && caseAccessExpressions.length > 1) {
            isCondition = $("#condition" + caseAccessExpressions[0].expressionId).val();
        }
        _.forEach(caseAccessExpressions, function (obj) {
            if (isCondition !== "") {
                if (obj.condition !== "" && obj.condition !== isCondition) {
                    obj.condition = isCondition;
                }
            }
            let optionValue = $('#attribute' + obj.expressionId).val();
            let option = _.find(optionList, { attribute: optionValue });
            if (option !== undefined && option !== null && option !== "") {
                obj.type = option.type
            }
        }
        );
        let newExpression = {
          id: null,
          expressionId : 1,
          attribute: "",
          operator: "eq",
          value: "",
          workflowId: selectWorkflow,
          condition: "",
          type: ""
        };

        var latestExpression = caseAccessExpressions ? caseAccessExpressions[caseAccessExpressions.length-1] : undefined;

        if(latestExpression!=undefined){
          newExpression.expressionId = latestExpression.expressionId+1
        }

        caseAccessExpressions.push(newExpression);
        this.setState({
          caseAccessExpressions: caseAccessExpressions,
          oldCondition: isCondition,
          selectedValue: ""
        });
    };

    removeCaseAccessExpression = idx => {
        const { caseAccessExpressions } = this.state;
        caseAccessExpressions.splice(idx, 1);
        let isCondition="";
        if(caseAccessExpressions.length>1){
            isCondition=$("#condition"+caseAccessExpressions[0].expressionId).val();
        }
        if (isCondition !== "") {
            _.forEach(caseAccessExpressions, function (obj) {
                if (obj.condition !== "" && obj.condition !== isCondition) {
                    obj.condition = isCondition;
                }
            }
            );
        }
        this.setState({
          caseAccessExpressions: caseAccessExpressions,
          oldCondition: isCondition
        });
    };

    handleSaveExpression = () => {
        const { caseAccessExpressions, selectWorkflow, workflowAttributes } = this.state;

        let newExData = [];
        caseAccessExpressions.forEach(item => {
            let value = "";
            if (item.type.toUpperCase() === "DATE") {
                value = item.value;
            } else {
                value = $('#expression' + item.expressionId).val();
            }
            let savedAttribute = $('#attribute' + item.expressionId).val();
            let workflowAttribute = _.find(workflowAttributes, { attribute: savedAttribute });
            if (workflowAttribute !== undefined && workflowAttribute !== null && workflowAttribute !== "") {
                item.type = workflowAttribute.type;
            }
            let record = {
                id: item.id,
                expressionId: item.expressionId,
                attribute: $('#attribute' + item.expressionId).val(),
                operator: $('#operator' + item.expressionId).val(),
                value: value,
                workflowId: selectWorkflow,
                condition: $('#condition' + item.expressionId).val(),
                type: item.type
            };
            newExData.push(record);
        })

        this.setState({
          caseAccessExpressions: newExData
        });

        $('#modal-customize-case-access').modal('hide');
        $('#modal-user-group').css('overflow-y', 'auto');
    };

    validationSaveExpression = () => {

        $(function () {
            $('#modal-case-state').modal('show');  
            $('#modal-case-state').css('overflow-y', 'auto');
        });

        
        const {  caseAccessExpressions,workflowAttributes } = this.state;
        let errorMsg="";
        let isValidate=true;
        caseAccessExpressions.forEach(item => {
            let value;
            const regexInteger = /^[+-]?\d+$/;
            const regexDecimal = /^[+-]?\d+(\.\d+)?$/;
            if(item.type.toUpperCase() === "DATE"){
                value=item.value;
            }else{
                value=$('#expression'+item.expressionId).val();
            }
            let savedAttribute = $('#attribute' + item.expressionId).val();
            let workflowAttribute = _.find(workflowAttributes, { attribute: savedAttribute });
            if (workflowAttribute !== undefined && workflowAttribute !== null && workflowAttribute !== "") {
                item.type = workflowAttribute.type;
                if (value != null){
                    var valueType="";
                    if (regexInteger.test(value)) {
                        valueType = 'integer';
                      } else if (regexDecimal.test(value)) {
                        valueType = 'decimal';
                      }
                    if(item.type.toLowerCase() == 'integer' ||item.type.toLowerCase() == 'decimal'){
                        if(valueType!==item.type.toLowerCase()){
                            isValidate=false;
                            errorMsg=item.type.toLowerCase();
                        }
                    }
                }
            }
        })
        if(isValidate){
            this.handleSaveExpression();
        }else{
            const { t } = this.state;
            $.notification("error", t("common.notification.error"), t("common.validations."+errorMsg));
        }
    }

    handleDateChange = (selectedExpression, val) => {
        const { caseAccessExpressions } = this.state;
        let expression = _.find(caseAccessExpressions, {
          expressionId: selectedExpression.expressionId
        });
        expression.value = val;
        this.setState({
          caseAccessExpressions: caseAccessExpressions
        });
      }

      changeAttribute = (event, optionList) => {
        const { autoSuggestedAttributeValues, caseAccessExpressions } = this.state;
        _.forEach(caseAccessExpressions, function (obj) {
          let attribute = $('#attribute' + obj.expressionId).val();
          let selected = _.find(optionList, { attribute: attribute });
          if (selected !== undefined && selected !== null && selected !== "") {
            obj.type = selected.type;
            obj.attribute = selected.attribute;
            if (selected.type.toUpperCase() === 'DATE') {
              if (typeof obj.value === "string") {
                obj.value = new Date();
              }
            } else {
              obj.value = "";
            }
          }
        }
        );
        const selectedValue = event.target.value;
        let selected = _.find(optionList, { attribute: selectedValue });
        if (selected !== undefined && selected !== null && selected !== "") {
          this.setState({
            selectedType: selected.type
          });
        }
        var id = event.target.id;
        id = id.replace('attribute', '');

        $( function() {

          function autocompleteExpression(inp, arr) {
            /*the autocomplete function takes two arguments,
            the text field element and an array of possible autocompleted values:*/
            var currentFocus;
            /*execute a function when someone writes in the text field:*/
            inp.addEventListener("input", function(e) {
              var a, b, i, val = this.value;
              /*close any already open lists of autocompleted values*/
              closeAllLists();
              if (!val) { return false;}
              currentFocus = -1;
              /*create a DIV element that will contain the items (values):*/
              a = document.createElement("DIV");
              a.setAttribute("id", this.id + "autocomplete-list");
              a.setAttribute("class", "autocomplete-items");
              /*append the DIV element as a child of the autocomplete container:*/
              this.parentNode.appendChild(a);
              /*for each item in the array...*/
              for (i = 0; i < arr.length; i++) {
                /*check if the item starts with the same letters as the text field value:*/
                if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                  /*create a DIV element for each matching element:*/
                  b = document.createElement("DIV");
                  /*make the matching letters bold:*/
                  b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                  b.innerHTML += arr[i].substr(val.length);
                  /*insert a input field that will hold the current array item's value:*/
                  b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                  /*execute a function when someone clicks on the item value (DIV element):*/
                  b.addEventListener("click", function(e) {
                    /*insert the value for the autocomplete text field:*/
                    inp.value = this.getElementsByTagName("input")[0].value;
                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    closeAllLists();
                  });
                  a.appendChild(b);
                }
              }
            });
            /*execute a function presses a key on the keyboard:*/
            inp.addEventListener("keydown", function(e) {
              var x = document.getElementById(this.id + "autocomplete-list");
              if (x) x = x.getElementsByTagName("div");
              if (e.keyCode == 40) {
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
              } else if (e.keyCode == 38) { //up
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x);
              } else if (e.keyCode == 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.preventDefault();
                if (currentFocus > -1) {
                  /*and simulate a click on the "autocompleteExpressionactive" item:*/
                  if (x) x[currentFocus].click();
                }
              }
            });
            function addActive(x) {
              /*a function to classify an item as "active":*/
              if (!x) return false;
              /*start by removing the "active" class on all items:*/
              removeActive(x);
              if (currentFocus >= x.length) currentFocus = 0;
              if (currentFocus < 0) currentFocus = (x.length - 1);
              /*add class "autocomplete-active":*/
              x[currentFocus].classList.add("autocomplete-active");
            }
            function removeActive(x) {
              /*a function to remove the "active" class from all autocomplete items:*/
              for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
              }
            }
            function closeAllLists(elmnt) {
              /*close all autocomplete lists in the document,
              except the one passed as an argument:*/
              var x = document.getElementsByClassName("autocomplete-items");
              for (var i = 0; i < x.length; i++) {
                if (elmnt != x[i] && elmnt != inp) {
                  x[i].parentNode.removeChild(x[i]);
                }
              }
            }
            /*execute a function when someone clicks in the document:*/
            document.addEventListener("click", function (e) {
              closeAllLists(e.target);
            });
          }
             if(autoSuggestedAttributeValues[0][selectedValue]!=undefined){
            autocompleteExpression(document.getElementById("expression"+id), autoSuggestedAttributeValues[0][selectedValue]);
           }

        });
      }

      generateSortedAttributeList =(workflowAttributesTemp)=> {
        let workflowAttributesSorted = !workflowAttributesTemp ? []: workflowAttributesTemp.map(option=> {
          let attribName = this.generateAttributeName(option.attribute);
          if (
            attribName.includes("sessionRef") ||
            attribName.includes("workflowRef") ||
            attribName.includes("worker") ||
            attribName.includes("Attachments") ||
            attribName.includes("Assign Worker") ||
            attribName.includes("sessionRef") ||
            attribName.includes("worker") ||
            attribName.includes("workflowRef") ||
            attribName.includes("workflowId") ||
            attribName.includes("workflowName") ||
            attribName.includes("workflowVersion") ||
            attribName.includes("baseURL") ||
            attribName.includes("continuationURL") ||
            attribName.includes("stateName") ||
            attribName.includes("stateType") ||
            attribName.includes("caseState")) {
            return {
              id: option.id,
              attribute: option.attribute,
              attributeName: `${attribName} (default)`,
              type: option.type
          }
          } else {
            return {
              id: option.id,
              attribute: option.attribute,
              attributeName: attribName,
              type: option.type
            }
          }
            })
        return sortWorkflowAttributes(workflowAttributesSorted);
    }

    generateAttributeName = (attribute) => {
        if(attribute.includes("metadata") || attribute.includes("auditInfo")){
            var valueArray = attribute.split(".");
            if(valueArray[1]!=undefined && valueArray[1]!=null){
                return valueArray[1];
            } else {
                return attribute;
            }
        } else {
            return attribute;
        }
    }
    addRecord = () => {
        const {
            caseActions,
            selectAction,
            records,
            handleRecords
        } = this.state;

        var selectedAction;
        var newData;

        if (selectAction != null) {
            selectedAction = _.find(caseActions, { id: selectAction });

            let record = {
                id: selectedAction.id,
                name: selectedAction.name,
                description: selectedAction.description,
                title : selectedAction.title,
                tooltip : selectedAction.tooltip,
                icon : selectedAction.icon,
                type : selectedAction.type,
                predefinedActions : selectedAction.predefinedActions,
                isCommentSection : selectedAction.isCommentSection,
                isMandatoryComment : selectedAction.isMandatoryComment,
                isCaseHistoryEntry : selectedAction.isCaseHistoryEntry,
                isCaseHistoryLogPdf : selectedAction.isCaseHistoryLogPdf,
                caseHistoryEntryTitle : selectedAction.caseHistoryEntryTitle,
                confirmActionButtonLabel : selectedAction.confirmActionButtonLabel,
                cancelActionButtonLabel : selectedAction.cancelActionButtonLabel,
                commentHintText : selectedAction.commentHintText,
                isTransitionState : selectedAction.isTransitionState,
                caseTransitionState : selectedAction.caseTransitionState,
                order : handleRecords.length+1,
                successMessage : selectedAction.successMessage,
                caseExpressions : selectedAction.caseExpressions,
                selectedWorkflowId : selectedAction.selectedWorkflowId,
                workflowLink : selectedAction.workflowLink
            };

            if (!_.find(handleRecords, { id: selectedAction.id })) {
                newData = [...handleRecords, record];
                this.setState({
                    handleRecords: newData
                });
            }
        }
    }

    deleteRecord = idx => {
        var handleRecords = this.state.handleRecords;
        var newData = [];
        handleRecords.forEach(item =>{
            let record = {
                id: item.id,
                name: item.name,
                description: item.description,
                title : item.title,
                tooltip : item.tooltip,
                icon : item.icon,
                type : item.type,
                predefinedActions : item.predefinedActions,
                isCommentSection : item.isCommentSection,
                isMandatoryComment : item.isMandatoryComment,
                isCaseHistoryEntry : item.isCaseHistoryEntry,
                isCaseHistoryLogPdf : item.isCaseHistoryLogPdf,
                caseHistoryEntryTitle : item.caseHistoryEntryTitle,
                confirmActionButtonLabel : item.confirmActionButtonLabel,
                cancelActionButtonLabel : item.cancelActionButtonLabel,
                commentHintText : item.commentHintText,
                isTransitionState : item.isTransitionState,
                caseTransitionState : item.caseTransitionState,
                successMessage : item.successMessage,
                order : item.order,
                caseExpressions : item.caseExpressions,
                selectedWorkflowId : item.selectedWorkflowId,
                workflowLink : item.workflowLink
            };
            newData.push(record);
        })

        newData.splice(idx, 1);
        newData = this.resetActionOrder(newData);
        this.setState({
            handleRecords: newData
        });
    };

    pinRecord = (idx, clickedId, recordId) => {
        this.setState({ selectedIdFromModal: clickedId, selectedRecordId: recordId });
    }

    generateTitle = (type, key, title) => {
        const {t} = this.props;
        var translation = t(type+"."+key);
        if(translation.includes(type)){
            return title;
        } else {
            return translation;
        }
    }

    moveUpCaseActionRecord = (type, record) => {
        const {
            handleRecords
        } = this.state;

        var  currentIndex = record.order;
        var  previousIndex = record.order-1;
        if(currentIndex==1){ return false;}

        if(type=="case_actions"){
            handleRecords.forEach(item =>{
                if(item.order==currentIndex){
                    item.order = currentIndex-1
                } else if(item.order==previousIndex) {
                    item.order = previousIndex+1
                }

                this.movePinnedNode(item);
            })

            this.setState({
                handleRecords: handleRecords
            });
        }
    }

    moveDownCaseActionRecord = (type, record) => {
        const {
            handleRecords
        } = this.state;

        var  currentIndex = record.order;
        var  nextIndex = record.order+1;

        if(type=="case_actions"){
            if(currentIndex==handleRecords.length){ return false;}
            handleRecords.forEach(item =>{
                if(item.order==currentIndex){
                    item.order = currentIndex+1
                } else if(item.order==nextIndex) {
                    item.order = nextIndex-1
                }

                this.movePinnedNode(item);
            })

            this.setState({
                handleRecords: handleRecords
            });
        }
    }

    resetActionOrder = list => {
        let order = 1;
        list.forEach(item =>{
            item.order = order;
            order++;
        })

        return list;
    }

    movePinnedNode(item) {
        if (item.id === this.state.selectedRecordId) {
            item.pinned = "true";

            if (item.pinned === "true" && item.type === "4") {
                this.setState({
                    selectedIdFromModal: item.order - 1
                });
            }
        }
    }
    handleCaseSelectButtonClick = (prop) => {
        this.setState({
            selectedButton: prop,
            isShowWFSelect:false
        });
        if (prop === "customeState") {
            $('#workflowStateNameRow').show();
        } else if (prop === "case_filter") {
            $('#workflowStateNameRow').hide();
            this.setState({ caseState: { ...this.state.caseState, workflowStateName: "" } });
            this.setState({
                isShowWFSelect:true
            });
        }else {
            $('#workflowStateNameRow').hide();
            this.setState({ caseState: { ...this.state.caseState, workflowStateName: prop } });
        }
    };

    openModalAfterExpression = () => {
        $(function () {
            $('#modal-case-state').modal('show');  
            $('#modal-case-state').css('overflow-y', 'auto');
        });
    };

    render() {
        const { t } = this.props;
        const { stateData, columns, data, isEdit, records, caseActions, errors, handleRecords, selectedButton, workflowList,workflowAttributes, selectWorkflow,  caseAccessExpressions, oldCondition, isShowWFSelect, attributesSorted, loading} = this.state;
        const deleteModalParams = { t }
        const stateDetailsParams = { t, stateData }
        const caseStateModalParams = { t, isEdit, errors, stateData, caseActions, handleRecords , selectedButton, selectWorkflow, workflowList, isShowWFSelect }
        const caseExpressionParams = { t, caseAccessExpressions, workflowAttributes, attributesSorted, oldCondition};
        return (
            <Fragment>
                <div className="content-wrapper portal-admin admin-case-tables">
                    <section className="content-header">
                        <h1>
                            {t("portalSettings.caseStates.title")} <small />
                        </h1>
                    </section>

                    <section className="content">
                        {loading && <Loading />}
                        <CommonTable 
                            rowClick={this.onRowClick} 
                            columns={columns} 
                            data={data} 
                            t={t}
                            initialSort={[{column: "name", dir: "asc"}]}
                        />

                        <CaseStateModal
                            params={caseStateModalParams}
                            addRecord={this.addRecord}
                            deleteRecord={this.deleteRecord}
                            pinRecord={this.pinRecord}
                            generateTitle={this.generateTitle}
                            handleChange={this.handleChange}
                            handleWorkflowChange={this.handleWorkflowChange}
                            handleCaseActionChange={this.handleCaseActionChange}
                            handleSave={this.handleSave}
                            moveUpCaseActionRecord={this.moveUpCaseActionRecord}
                            moveDownCaseActionRecord={this.moveDownCaseActionRecord}
                            clickedId={this.state.selectedIdFromModal}
                            handleCaseSelectButtonClick={this.handleCaseSelectButtonClick}
                        />

                            <CaseExpression params={caseExpressionParams}
                            addCaseAccessExpression={this.addCaseAccessExpression}
                            removeCaseAccessExpression={this.removeCaseAccessExpression}
                            handleSaveExpression={this.handleSaveExpression}
                            openSpecifyWindow={this.openModalAfterExpression}
                            validationSaveExpression={this.validationSaveExpression}
                            handleDateChange={this.handleDateChange}
                            changeAttribute={this.changeAttribute}
                            title={t("portalSettings.caseStates.caseAccess.title")}
                        />


                        <div className="row">

                            <StateDetails
                                params={stateDetailsParams}
                            />

                            <div className="col-xs-4 right">
                                <div className="box">
                                    <div className="box-header">
                                        <div className="box-title">
                                            <p className="lead" style={{marginBottom:0}}>{t("portalSettings.caseStates.actions.title")}</p>
                                        </div>
                                    </div>
                                    <div className="box-body">
                                        {!isEdit && (
                                        <a
                                            href="#/"
                                            className="btn btn-app"
                                            onClick={e => {
                                                e.preventDefault();
                                                this.openModal();
                                            }}
                                        >
                                              <span
                                                  className="fa fa-plus"
                                                  data-toggle="tooltip"
                                                  title="Add"
                                              />
                                            {t("common.add")}
                                        </a>
                                        )}
                                        {stateData &&
                                            <CommonActionButton
                                                params={this.props.t}
                                                reverseOnRowClick={this.reverseOnRowClick}
                                                openModal={this.openModal}
                                            />}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <DeleteModal
                            type="state"
                            id="caseStateDeleteAlert"
                            params={deleteModalParams}
                            stateDataId={stateData?.id}
                            stateDataName={stateData?.name}
                            deleteFunction={this.deleteCaseState}
                            message="portalSettings.caseStates.delete.message"
                        />

                    </section>
                </div>
            </Fragment>
        );
    }
}

export default withTranslation("common")(SettingsCaseStatePage);